
    import Vue from 'vue';

    export default Vue.extend({
        name: "LoadingIndicator",
        data() {
            return {
                show: false
            };
        },
        created() {
            this.$eventBus.$on("show-loading", () => {
                this.show = true
            });
            this.$eventBus.$on("hide-loading", () => {
                this.show = false
            });
        }
    });
